<template>
  <div class="sidebarWrapper">
      <div class="time">
          <div class="hours">
            {{time.getHours()}}:{{time.getMinutes().toString().length==1 ?`0${time.getMinutes()}`:time.getMinutes()}}
          </div>
          <div class="week">
            {{ weekLsit[time.getDay()]}}
          </div>
          <div class="date">
            {{ time.getFullYear() }}.{{time.getMonth()+1}}.{{time.getDate()}}

          </div>
      </div>
      <div class="listBox">
        <div class="pageList" v-for=" (item,index) in pageList" :key='item.path'  :class="{'active':active==index}"  @click="jump(item.path,index)">
            {{item.name}}
        </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            pageList:[],
            weekLsit:['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
            time:new Date(),
            active:0
        }
    },
    mounted(){
        let a = setInterval(()=>{
            this.time = new Date()
        },1000)
        let routes = this.$router.options.routes[2].children
        routes.forEach(e => {
                let ex  = {}
                ex.name = e.meta.name
                ex.path = e.path
                this.pageList.push(ex)
        });
        this.pageList.forEach((e,i)=>{
            if(e.path == this.$route.path){
                this.active = i
            }
        })
    },
    methods:{
        jump(e,i){
            if(e!==this.$route.path){
                this.active=i
                this.$router.replace(e)
            }
        }
    }

}
</script>

<style lang="scss" >
.sidebarWrapper{
    background-color: #D9E1EC;
    width: 10.5%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .time{
        margin-top: 5rem;
        .hours{
            font-size: 1.33rem;
            font-family: BodoniXT;
            font-weight: 400;
            color: #3E3A39;
            margin-bottom: 10px;
        }
        .week{
            font-size: 0.75rem;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #3E3A39;
            margin-bottom: 5px;
        }
        .date{
            font-size: 0.83rem;
            font-family: BodoniXT;
            font-weight: 400;
            color: #3E3A39;
            margin-bottom: 5px;
        }
    }
    .listBox{
        margin-top: 2rem;
        font-size: 0.85rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #3E3A39;
        cursor: pointer;
        .active{
            font-size: 1rem;
            font-weight: bold;
        }
        .pageList{
            margin-bottom: 1rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/sidebar.vue